import React, { useState } from "react";
import Modal from "react-modal";
import { IoIosClose } from "react-icons/io";
import { useLoader } from "../../../../../base/context/LoaderProvider";
import { ToastTypes, useMessage } from "../../../../../base/context/MessageProvider";
import { orderApiService } from "../../../../../service/admin/ordersApiService";
import "./style.css";

const customStyles = {
  overlay: {
    zIndex: 1050,
    background: "rgba(15, 23, 42, 0.4)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 24,
  },
  content: {
    position: "relative",
    inset: "auto",
    margin: 0,
    padding: 0,
    border: "none",
    borderRadius: "12px",
    background: "#fff",
    boxShadow: "0 20px 40px rgba(0, 0, 0, 0.15), 0 0 1px rgba(0, 0, 0, 0.1)",
    maxWidth: "400px",
    width: "100%",
    maxHeight: "calc(100vh - 48px)",
    overflow: "auto",
  },
};

export default function AdminRaiseTicketModal({
  modalIsOpen,
  setIsOpen,
  orderId,
  handleRefresh,
}) {
  const [data, setData] = useState({ issue: "" });
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const message = useMessage();
  const loader = useLoader();

  function closeModal() {
    if (!submitting) setIsOpen(false);
  }

  const handleOnChange = (e) => {
    setData({ ...data, issue: e.target.value });
    setError("");
  };

  const validate = () => {
    if (!data.issue || !String(data.issue).trim()) {
      setError("Issue is required");
      return false;
    }
    return true;
  };

  const handleRaiseTicket = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setSubmitting(true);
    loader.showLoading(true);
    try {
      const payload = JSON.stringify({ issue: data.issue.trim() });
      const res = await orderApiService.raiseTicketForOrder(orderId, payload);
      loader.showLoading(false);
      setSubmitting(false);

      if (res.status.code === 200) {
        message.showToast(res.status.message || "Ticket created successfully", ToastTypes.SUCCESS);
        closeModal();
        if (handleRefresh) handleRefresh();
      } else {
        message.showToast(res.error?.message || "Failed to create ticket", ToastTypes.ERROR);
      }
    } catch (err) {
      loader.showLoading(false);
      setSubmitting(false);
      message.showToast(err?.message || "Server error. Try again later", ToastTypes.ERROR);
    }
  };

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="Raise ticket for order"
      ariaHideApp={typeof document !== "undefined"}
    >
      <div className="admin-raise-ticket-modal">
        <div className="admin-raise-ticket-modal-header">
          <h2 className="admin-raise-ticket-modal-title">Raise a Ticket</h2>
          <button
            type="button"
            className="admin-raise-ticket-modal-close"
            onClick={closeModal}
            aria-label="Close"
          >
            <IoIosClose size={24} />
          </button>
        </div>

        <form onSubmit={handleRaiseTicket}>
          <div className="admin-raise-ticket-modal-body">
            <p className="admin-raise-ticket-modal-hint">
              This ticket will appear in Ticket Management and the seller will see it on their order.
            </p>
            <label htmlFor="admin-raise-ticket-issue" className="admin-raise-ticket-modal-label">
              Message for seller
            </label>
            <textarea
              id="admin-raise-ticket-issue"
              className={`admin-raise-ticket-modal-textarea ${error ? "admin-raise-ticket-modal-textarea-error" : ""}`}
              value={data.issue}
              onChange={handleOnChange}
              placeholder="Describe the issue or message..."
              rows={4}
              disabled={submitting}
            />
            {error ? <p className="admin-raise-ticket-modal-error">{error}</p> : null}
          </div>

          <div className="admin-raise-ticket-modal-footer">
            <button
              type="button"
              className="admin-raise-ticket-modal-btn-cancel"
              onClick={closeModal}
              disabled={submitting}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="admin-raise-ticket-modal-btn-submit"
              disabled={submitting}
            >
              {submitting ? "Submitting…" : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
}
